export const APPROVAL_LIST = {
	GET_ALL_USER_APPLICATIONS: 'APPROVAL_LIST_GET_ALL_USER_APPLICATIONS',
	SET_ALL_USER_APPLICATIONS: 'APPROVAL_LIST_SET_ALL_USER_APPLICATIONS',
	SET_USER_STATUS: 'APPROVAL_LIST_SET_USER_STATUS',
};
